const DEX_TYPE = {
	SGTRADEX: 'sgtradex',
	SGBUILDEX: 'sgbuildex',
	SGHEALTHDEX: 'sghealthdex'
}

const sessionKeys = {
	unseenPivotNotificationId: 'unseenPivotNotificationId',
}

export {
	sessionKeys,
	DEX_TYPE
}

